var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategorySeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.128 43.704L8.932 36.224H1.628L2.552 32.308H9.724L11.924 23.64H4.532L5.456 19.724H12.76L14.696 11.496H19.14L17.248 19.724H24.86L26.796 11.496H31.196L29.348 19.724H36.696V19.768L35.816 23.64H28.512L26.444 32.308H33.792L32.868 36.224H25.652L23.892 43.704H19.228L21.032 36.224H13.508L11.792 43.704H7.128ZM14.3 32.308H21.824L24.024 23.64H16.412L14.3 32.308Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.72 39V36.756C42.2413 36.7333 42.672 36.6653 43.012 36.552C43.3747 36.4387 43.6467 36.178 43.828 35.77C44.032 35.362 44.134 34.7047 44.134 33.798V20.164L40.428 22.374L39.204 20.334L46.99 14.656H49.03V33.424C49.03 34.036 49.0187 34.6253 48.996 35.192C48.996 35.7587 48.9733 36.1893 48.928 36.484C49.2907 36.4387 49.744 36.416 50.288 36.416C50.8547 36.3933 51.2513 36.382 51.478 36.382V39H41.72Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategorySeo);
export default __webpack_public_path__ + "react/media/category-seo.85cbdc172a967f1f999a830b76d65de8.svg";
export { ForwardRef as ReactComponent };